import { actionDeclarer } from '../services/actionDeclarer';

export const {
	SET_AGENCIES,
	SET_MANAGEMENT,
	SET_NOTIFICATION_DIGEST_TYPES,
	SET_NOTIFICATION_TYPES,
	SET_USER,
	SET_USER_LIST,
	SET_USER_ROLES,
	SET_TABLE_STATE
} = actionDeclarer;

const usersReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SET_AGENCIES:
			return {
				...state,
				agencyOrganizations: payload
			};
		case SET_MANAGEMENT:
			return {
				...state,
				managementOrganizations: payload
			};
		case SET_NOTIFICATION_DIGEST_TYPES:
			return {
				...state,
				notificationDigestTypes: payload
			};
		case SET_NOTIFICATION_TYPES:
			return {
				...state,
				notificationTypes: payload
			};
		case SET_TABLE_STATE:
			return {
				...state,
				tableState: payload( state.tableState )
			};
		case SET_USER:
			return {
				...state,
				user: payload
			};
		case SET_USER_LIST:
			return {
				...state,
				userList: payload
			};
		case SET_USER_ROLES:
			return {
				...state,
				userRoles: payload
			};
		default:
			return state;
	}
};

export default usersReducer;
